(function() { module.exports = window["wp"]["domReady"]; }());